import {
    useEffect,
    useState
} from 'react';

import {

    getAllStoryComments,

    deleteStoryComment

} from '../../../api/adminApi';

import './AppCommentManage.css';

const AppCommentManage = () => {

    const [keyword, setKeyword] =
        useState('');

    const [currentPage, setCurrentPage] =
        useState(1);

    const [comments, setComments] =
        useState<any[]>([]);

    useEffect(() => {

        fetchComments();

    }, [keyword, currentPage]);

    const fetchComments = async () => {

        try {

            const response =
                await getAllStoryComments(

                    currentPage,

                    keyword

                );

            setComments(
                response.data || []
            );

        } catch (e) {

            console.error(e);

            setComments([]);
        }
    };

    const handleDeleteComment = async (
        id: number
    ) => {

        if (
            !window.confirm(
                '댓글을 삭제하시겠습니까?'
            )
        ) {

            return;
        }

        await deleteStoryComment(
            id
        );

        fetchComments();
    };

    return (

        <div className="comment-manage">

            <div className="comment-search-wrap">

                <input

                    type="text"

                    placeholder="앱 댓글 검색"

                    value={keyword}

                    onChange={(e) => {

                        setKeyword(
                            e.target.value
                        );

                        setCurrentPage(1);
                    }}

                    className="comment-search-input"
                />

            </div>

            <div className="comment-table-header">

                <div>번호</div>

                <div>댓글</div>

                <div>이야기ID</div>

                <div>작성자</div>

                <div>날짜</div>

                <div>관리</div>

            </div>

            <div className="comment-table">

                {

                    comments?.map(

                        (comment) => (

                            <div

                                className="comment-row"

                                key={comment.id}
                            >

                                <div>

                                    {comment.id}

                                </div>

                                <div>

                                    {comment.content}

                                </div>

                                <div>

                                    {comment.storyId}

                                </div>

                                <div>

                                    {comment.nickname}

                                </div>

                                <div>

                                    {

                                        comment.createdAt

                                            ? new Date(
                                                comment.createdAt
                                            ).toLocaleString(
                                                'sv-SE'
                                            )

                                            : '-'
                                    }

                                </div>

                                <div>

                                    <button

                                        className="comment-delete-button"

                                        onClick={() =>

                                            handleDeleteComment(
                                                comment.id
                                            )
                                        }
                                    >

                                        삭제

                                    </button>

                                </div>

                            </div>

                        )
                    )
                }

            </div>

        </div>

    );
};

export default AppCommentManage;